import { ref } from "vue";

/**
 * True once a route chunk, a lazy import or its CSS failed to load. Read by ChunkLoadError.vue.
 * Nothing is stored: a reload starts from scratch and the message goes away with the page.
 */
export const chunkLoadFailed = ref(false);

export function showChunkLoadFailure() {
	chunkLoadFailed.value = true;
}
